<template>
  <div>
    <div class="d-flex w-100 align-items-center">
      <b-form-group class="mb-0" v-slot="{ ariaDescribedby }">
        <b-form-radio-group
          v-model="selected"
          :aria-describedby="ariaDescribedby"
        >
          <b-form-radio
            v-for="(item, index) in options"
            :key="index"
            :value="item.id"
            class="mr-4"
          >
            {{ item.text }}
          </b-form-radio>
        </b-form-radio-group>
      </b-form-group>
    </div>
    <div v-show="isFailValidation" class="is-invalid-feedback-message">
      {{ textValidation }}
    </div>
  </div>
</template>

<script>
import handleValidateMixin from "@/mixins/handle-validate-mixin";
import { formatConstantToArray } from "@/helpers/common";
import { memberClassType } from "@/constants/commons";

export default {
  name: "MemberClassTypeRadio",
  mixins: [handleValidateMixin],
  data() {
    return {
      options: [],
    };
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit("input", newVal);
      },
    },
  },
  created() {
    this.options = formatConstantToArray(memberClassType);
  },
};
</script>
